import { FETCH_SHOWCASE_SUCCESS } from 'Catalog/Showcase/ducks'
import { FETCH_SEARCH_SUCCESS } from 'Catalog/Search/ducks'

export const FETCH_PRODUCT = 'products/FETCH'
export const FETCH_PRODUCT_SUCCESS = `${FETCH_PRODUCT}_SUCCESS`
export const FETCH_PRODUCT_FAIL = `${FETCH_PRODUCT}_FAIL`

export const fetchProduct = sku => ({
  type: FETCH_PRODUCT,
  sku,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'GET',
      url: `/v2/products/skus/${sku}`
    }
  }
})

export default (state = {}, action) => {
  let hotProducts = {}

  switch (action.type) {
    case FETCH_PRODUCT_SUCCESS:
      var {
        name,
        description,
        features: productFeatures,
        skus,
        vendor,
        brand
      } = action.payload.data

      hotProducts = skus.reduce((products, currentProduct) => {
        const {
          sku: currentSku,
          originalId,
          images,
          skuFeatures: features
        } = currentProduct

        return {
          ...products,
          [currentSku]: {
            ...state[currentSku],
            name,
            originalId,
            vendorId: vendor && String(vendor.id),
            vendorName: vendor && vendor.name,
            brandId: brand && String(brand.id),
            description,
            images,
            features,
            productFeatures,
            skus: skus
              .filter(({ sku }) => sku !== currentSku)
              .map(({ sku }) => sku)
          }
        }
      }, {})
      return { ...state, ...hotProducts }
    case FETCH_SHOWCASE_SUCCESS:
    case FETCH_SEARCH_SUCCESS:
      hotProducts = action.payload.data.products.reduce(
        (products, currentProduct) => {
          const {
            sku,
            name,
            originalId,
            vendor,
            imageUrl,
            brand
          } = currentProduct

          return {
            ...products,
            [sku]: {
              ...state[sku],
              name,
              originalId,
              vendorId: vendor && String(vendor.id),
              brandId: brand && String(brand.id),
              imageUrl
            }
          }
        },
        {}
      )
      return { ...state, ...hotProducts }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Product/ducks.js